import { Component, Inject } from '@angular/core';
import { licenseActions } from '@src/store/reducers/licenseReducer';
import { Store } from '@src/store';

@Component({
    selector: 'license',
    template: require('./license.component.html'),
    styles: [require('./license.component.scss')]
})
export class LicenseComponent {
    public licenseFile: any;
    public allowedFilesTypes: string;

    constructor(private store: Store,
                @Inject('$state') private state: any,
                @Inject('fileUploader') private fileUploader: any) {
        this.allowedFilesTypes = 'lic';
        this.licenseFile = null;
    }

    public processLicense(files) {
        this.licenseFile = files[0];
    }

    public uploadLicense() {
        const payload = {
            uploadObject: this.fileUploader.getUploader(),
            file: this.licenseFile,
            onResult: () => { this.state.go('app.auth.login'); }
        };
        this.store.dispatch({ type: licenseActions.UPLOAD_LICENSE, payload: payload });
    }

    public cancel() {
        this.state.go('app.auth.login');
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authentication/license/license.component.ts